/* eslint-disable no-redeclare */
import { useOidc } from '@/features/oidc/oidc'
import { OidcReact } from 'oidc-spa/react'
import { useTracking } from '@vgw/multibrand-fe-tracking'

type PlayerSessionLoggedIn = {
  isUserLoggedIn: true
  login?: never
  logout: (
    params: Parameters<OidcReact.LoggedIn<Record<string, string>>['logout']>[0],
  ) => Promise<void>
}

type PlayerSessionNotLoggedIn = {
  isUserLoggedIn: false
  login: (
    params: Parameters<OidcReact.NotLoggedIn['login']>[0],
  ) => Promise<void>
  logout?: never
}

export function usePlayerSession(params: {
  assumeLoggedIn: false
}): PlayerSessionNotLoggedIn
export function usePlayerSession(params: {
  assumeLoggedIn: true
}): PlayerSessionLoggedIn
export function usePlayerSession(params?: {
  assumeLoggedIn?: undefined
}): PlayerSessionNotLoggedIn | PlayerSessionLoggedIn
export function usePlayerSession(params?: {
  assumeLoggedIn?: boolean
}): PlayerSessionLoggedIn | PlayerSessionNotLoggedIn {
  const { isUserLoggedIn, login, logout } = useOidc()
  const { reset } = useTracking()

  if (params?.assumeLoggedIn === true || isUserLoggedIn) {
    return {
      isUserLoggedIn: true,
      logout: async (
        params: Parameters<
          OidcReact.LoggedIn<Record<string, string>>['logout']
        >[0],
      ) => {
        // Reset prevents login and registration events from being assigned to the current user
        // Without it, tracking multiple players on the same browser will be incorrect
        reset()
        return logout?.(params)
      },
    }
  }

  return {
    isUserLoggedIn: false,
    login: async (params: Parameters<OidcReact.NotLoggedIn['login']>[0]) => {
      // Reset prevents login and registration events from being assigned to the current user
      // Without it, tracking multiple players on the same browser will be incorrect
      reset()
      return login?.(params)
    },
  }
}
